import { AutoComplete } from 'antd';
import MaterialIcon from 'material-icons-react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import styles from './search.css';
import { clearSelected, selectTypeahead, typeahead, doSearch } from './searchActions';


const Option = AutoComplete.Option;

class SearchComponent extends Component {

  constructor(props) {
    super(props);
  }

  onSelect(value, option) {

    if (value === '0_0') {

      return this.props.history.push('/sokning?q='+encodeURIComponent(this.props.query));
    }

    this.props.dispatch(selectTypeahead(value));
  }

  onSearch(query) {
    this.props.dispatch(typeahead(query));
  }

  render() {

    let { selected } = this.props;

    if (selected) {
      this.props.dispatch(clearSelected());

      if (selected.documentTypeId === 1 || selected.documentTypeId === 3 || selected.documentTypeId === 4 || selected.documentTypeId === 7) {
        return <Redirect to={`/rattsfall/${selected.id}`} />;
      }
      else if (selected.documentTypeId === 5) {
        return <Redirect to={`/nyhetsbrev/${selected.id}`} />;
      }
      else if (selected.documentTypeId === 2 || selected.documentTypeId === 6) {
        return <Redirect to={`/lagdel/lag/${selected.id}`} />;
      }
    }

    const children = this.props.result.map((r) => {
      return (<Option key={`${r.documentTypeId}_${r.id}`} className="search-auto-complete" >
        <MaterialIcon icon={r.icon} size={16} />
        <span>{r.title}</span>
      </Option>);
    });

    return (
      <AutoComplete
        allowClear={true}
        placeholder="sök..."
        value={this.props.query}
        onSearch={(q) => this.onSearch(q)}
        onSelect={(value, option) => this.onSelect(value, option)}
        style={styles.searchInput} >
        {children}
      </AutoComplete>
    )
  }
}


const mapStateToProps = (state) => ({
  query: state.search.query,
  result: state.search.result,
  selected: state.search.selected
});

export default connect(mapStateToProps)(withRouter(SearchComponent));



// WEBPACK FOOTER //
// ./src/search/searchComponent.js